import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Checkbox } from '@material-ui/core';
import { Search } from '@material-ui/icons'

export const GreenCheckbox = withStyles({
  root: {
    color: '#43a04754',
    '&$checked': {
      color: '#43a047',
    },
    '&:hover': {
      color: '#43a047',
      backgroundColor: 'initial'
    },
  },
  checked: {},
})(props => <Checkbox color="default" {...props} />);

export const BlueZoomInIcon = withStyles({
  root: {
    color: 'white',
    background: '#3c57e9',
    fontSize: 18,
    padding: 1,
    borderRadius: '50%'
  }
})(props => <Search {...props} />)

export const useStyles = makeStyles({
  cardItem: {
    position: 'relative',
    padding: 15,
  },
  cardItemContent: {
    width: '100%',
    borderRadius: 4,
    border: '1px solid #fff',
    transition: 'all 0.5s',
    cursor: 'pointer',
    position: 'relative',
    "&:hover": {
      transform: "translateY(-5px)",
      boxShadow: "0px 8px 14px -5px rgba(0,0,0,0.75)"
    }
  },
  itemCheckbox: {
    position: 'absolute',
    top: 0,
    right: 0,
    zIndex: 7,
    transition: 'all 0.5s',
    display: 'none',
  },
  hideCheckbox: {
    display: 'none',
  },
  showCheckbox: {
    display: 'initial',
  },
  itemZoomIn: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    zIndex: 7,
    padding: 9,
    transition: 'all 0.5s',
    display: 'none',
  },
  hideZoomIn: {
    display: 'none',
  },
  showZoomIn: {
    display: 'initial',
  },

  //Error,Sucess,Animations
  cardSelected: {
    border: '1px solid #699e42',
  },
  cardStatusDebtLate: {
    borderBottom: '6px solid #d82929',
  },
  cardStatusDebt: {
    borderBottom: '2px solid black',
  },
  cardStatusDebtPayable: {
    borderBottom: '2px solid #7bb94e',
  }
})
